module.exports = __webpack_public_path__ + "img/ES0061.ac0b1081.png";